module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timeline"
  }, [_vm._l((_vm.items), function(item) {
    return _vm._t("item", [_c('router-link', {
      staticClass: "timeline-item",
      attrs: {
        "to": item.route
      }
    }, [_c('h5', {
      staticClass: "timeline-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "timeline-subtitle"
    }, [_vm._v(_vm._s(item.subtitle))]), _vm._v(" "), _c('div', {
      staticClass: "timeline-date"
    }, [_vm._v(_vm._s(_vm._f("timelineDate")(item.created)))])])], {
      title: item.title,
      subtitle: item.subtitle,
      created: item.created,
      route: item.route
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2675ba13"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-route-timeline/src/components/RouteTimeline.vue
// module id = 104
// module chunks = 1